export const SINGLE_SELECT = 'singleSelectFields';
export const MULTI_SELECT = 'multipleSelectFields';
export const USER_SELECT = 'singleSelectClearableUserPickerFields';
export const USER_MULTI_SELECT = 'multipleSelectClearableUserPickerFields';
export const TEAM_SELECT = 'atlassianTeamFields';
export const LABELS = 'labelsFields';
export const NUMBER = 'clearableNumberFields';
export const STRING = 'singleLineTextFields';
